export default str => str.replace(/ID/g, "Id").replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
